<template>
    <div class="lb-object-toolbar">
        <div v-if="renderOption('images')" class="column is-flex">
            <button
                :title="$t('creation.image_type_hint')"
                class="button is-narrow"
                @click="$emit('click', { type: 'image' })"
            >
                <span class="icon">
                    <i class="fas fa-image" />
                </span>
            </button>
        </div>
        <div v-if="renderOption('audio')" class="column is-flex">
            <button
                :title="$t('creation.audio_type_hint')"
                class="button is-narrow"
                @click="$emit('click', { type: 'audio' })"
            >
                <span class="icon">
                    <i class="fas fa-volume-up" />
                </span>
            </button>
        </div>
        <div v-if="renderOption('video')" class="column is-flex">
            <button
                :title="$t('creation.video_type_hint')"
                class="button is-narrow"
                @click="$emit('click', { type: 'video' })"
            >
                <span class="icon">
                    <i class="fab fa-youtube" />
                </span>
            </button>
        </div>
        <div v-if="renderOption('url')" class="column is-flex">
            <button
                :title="$t('creation.link_type_hint')"
                class="button is-narrow"
                @click="$emit('click', { type: 'url' })"
            >
                <span class="icon">
                    <i class="fas fa-link" />
                </span>
            </button>
        </div>
        <div v-if="renderOption('location') && hasMap" class="column is-flex">
            <button
                :title="$t('creation.position_type_hint')"
                class="button is-narrow"
                @click="$emit('click', { type: 'location' })"
            >
                <span class="icon">
                    <i class="fas fa-map-marker-alt" />
                </span>
            </button>
        </div>

        <div v-if="renderOption('tags')" class="column is-flex">
            <button
                :title="$t('creation.tag_type_hint')"
                class="button is-narrow"
                @click="$emit('click', { type: 'tags' })"
            >
                <span class="icon">
                    <i class="fas fa-tag" />
                </span>
            </button>
        </div>
        <div v-if="renderOption('files')" class="column is-flex">
            <button
                :title="$t('creation.file_type_hint')"
                class="button is-narrow"
                @click="$emit('click', { type: 'files' })"
            >
                <span class="icon">
                    <i class="fas fa-file" />
                </span>
            </button>
        </div>
        <div v-if="renderOption('embed')" class="column is-flex">
            <button
                :title="$t('creation.embed_type_hint')"
                class="button is-narrow"
                @click="$emit('click', { type: 'embed' })"
            >
                <span class="icon">
                    <i class="fas fa-code" />
                </span>
            </button>
        </div>

        <!--<button
        :title="$t('creation.options_hint')"
        class="button dropdown is-hoverable is-right is-up"
      >
        <span class="icon">
          <i class="fas fa-ellipsis-v" />
        </span>
        <div 
          class="dropdown-menu" 
          role="menu">
          <div class="dropdown-content has-text-left">
            <a
              v-if="renderOption('tags')"
              :title="$t('creation.tag_type_hint')"
              class="dropdown-item has-text-weight-normal"
              @click="$emit('click', { type: 'tags' })"
            >
              <span class="icon">
                <i class="fas fa-tag" />
              </span>
              <span v-t="'creation.tag_type_hint'"></span>
            </a>
            <a
              v-if="renderOption('files')"
              :title="$t('creation.file_type_hint')"
              class="dropdown-item has-text-weight-normal"
              @click="$emit('click', { type: 'files' })"
            >
              <span class="icon">
                <i class="fas fa-file" />
              </span>
              <span v-t="'creation.file_type_hint'"></span>
            </a>
            <a
              v-if="renderOption('embed')"
              :title="$t('creation.embed_type_hint')"
              class="dropdown-item has-text-weight-normal"
              @click="$emit('click', { type: 'embed' })"
            >
              <span class="icon">
                <i class="fas fa-code" />
              </span>
              <span v-t="'creation.embed_type_hint'"></span>
            </a>
          </div>
        </div>
    </button>-->
    </div>
</template>

<script>
import _ from 'underscore';
export default {
    props: {
        expanded: { type: Boolean, default: true },
        options: { type: Array, default: () => [] },
    },
    methods: {
        renderOption(option) {
            return !!_.findWhere(this.options, { name: option });
        },
    },
    computed: {
        hasMap() {
            return (
                this.$store.getters.project.type == 'collection' &&
                this.$store.getters.project.mode == 'map'
            );
        },
    },
};
</script>

<style scoped>
button {
    border: unset !important;
}
.button.dropdown {
    padding-right: 0;
}
.button > .dropdown-menu {
    min-width: 6rem;
}
</style>
